var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "pa-3 card-historico" },
    [
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "d-flex align-center", attrs: { cols: "7" } },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "primary" } },
                [_vm._v("mdi-history")]
              ),
              _c("h4", { staticClass: "bold mb-0" }, [
                _vm._v("Histórico de status")
              ]),
              _vm.historicoOrdenado.length
                ? _c(
                    "v-chip",
                    {
                      staticClass: "ml-2",
                      attrs: { small: "", color: "primary", outlined: "" }
                    },
                    [_vm._v(" " + _vm._s(_vm.historicoOrdenado.length) + " ")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "d-flex justify-end", attrs: { cols: "5" } },
            [
              _vm.isSuperAdmin
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        small: "",
                        disabled:
                          _vm.loadingHistorico || _vm.loadingSalvarHistorico
                      },
                      on: { click: _vm.abrirAdicionar }
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-plus")
                      ]),
                      _vm._v(" Adicionar ")
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.isSuperAdmin
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "py-0" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-2 caption",
                      attrs: { dense: "", text: "", type: "info" }
                    },
                    [
                      _vm._v(" Área restrita a "),
                      _c("strong", [_vm._v("Super Admin")]),
                      _vm._v(
                        ". Toda criação, edição ou exclusão grava o seu usuário e gera trilha de auditoria nos comentários do título. "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-row",
        [
          _c("v-col", { staticClass: "pt-1" }, [
            !_vm.historicoOrdenado.length
              ? _c(
                  "div",
                  { staticClass: "empty-state" },
                  [
                    _c(
                      "v-icon",
                      { attrs: { large: "", color: "grey lighten-1" } },
                      [_vm._v("mdi-timeline-clock-outline")]
                    ),
                    _c("p", { staticClass: "grey--text mt-2 mb-0" }, [
                      _vm._v(" Nenhum histórico encontrado. ")
                    ])
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "bg-historico" },
                  _vm._l(_vm.historicoOrdenado, function(status) {
                    return _c(
                      "div",
                      {
                        key:
                          status.id_historico ||
                          status.dt_historico + status.cd_status,
                        staticClass: "historico-item"
                      },
                      [
                        _c("div", { staticClass: "historico-dot" }),
                        _c("div", { staticClass: "historico-body" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center flex-wrap" },
                            [
                              _c("strong", { staticClass: "historico-data" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.dataExibicao(status)) + " "
                                )
                              ]),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    "x-small": "",
                                    color: "primary",
                                    outlined: "",
                                    title: "Código do status"
                                  }
                                },
                                [
                                  _vm._v(
                                    " #" +
                                      _vm._s(_vm.codigoStatus(status)) +
                                      " "
                                  )
                                ]
                              ),
                              status.dt_arquivo_movimento
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ml-1",
                                      attrs: {
                                        "x-small": "",
                                        color: "teal",
                                        outlined: "",
                                        title: "Data de movimento do arquivo"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "", left: "" } },
                                        [_vm._v("mdi-file-clock-outline")]
                                      ),
                                      _vm._v(" movimento ")
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("v-spacer"),
                              _vm.isSuperAdmin
                                ? _c(
                                    "div",
                                    { staticClass: "historico-actions" },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              icon: "",
                                                              "x-small": "",
                                                              color: "primary",
                                                              disabled:
                                                                _vm.loadingHistorico ||
                                                                _vm.loadingSalvarHistorico
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.abrirEdicao(
                                                                  status
                                                                )
                                                              }
                                                            }
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: { small: "" }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-pencil-outline"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("Editar status / datas")
                                          ])
                                        ]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              icon: "",
                                                              "x-small": "",
                                                              color: "error",
                                                              disabled:
                                                                _vm.loadingHistorico
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.pedirExclusao(
                                                                  status
                                                                )
                                                              }
                                                            }
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: { small: "" }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-trash-can-outline"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("Excluir histórico")
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("div", { staticClass: "historico-descricao" }, [
                            _vm._v(" " + _vm._s(status.DESCRICAO) + " ")
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex align-center flex-wrap mt-1"
                            },
                            [
                              status.user_id
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "mr-1 mb-1",
                                      attrs: {
                                        "x-small": "",
                                        color: "indigo",
                                        outlined: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "", left: "" } },
                                        [_vm._v("mdi-account-check-outline")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            status.ds_login ||
                                              status.nm_user ||
                                              "usuário #" + status.user_id
                                          ) +
                                          " "
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-chip",
                                    {
                                      staticClass: "mr-1 mb-1",
                                      attrs: { "x-small": "", outlined: "" }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "", left: "" } },
                                        [_vm._v("mdi-robot-outline")]
                                      ),
                                      _vm._v(" sistema ")
                                    ],
                                    1
                                  ),
                              status.user_id
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "", "max-width": "350" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "px-1",
                                                        attrs: {
                                                          "x-small": "",
                                                          text: "",
                                                          color: "primary"
                                                        }
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(" Detalhes "),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          right: ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-information-outline"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " Ação registrada pelo usuário: "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              status.ds_login || status.nm_user
                                            )
                                          )
                                        ]),
                                        status.user_id
                                          ? _c("span", [
                                              _vm._v(
                                                " (#" +
                                                  _vm._s(status.user_id) +
                                                  ") "
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isAdmin && status.id_historico
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "caption grey--text ml-auto"
                                    },
                                    [
                                      _vm._v(
                                        " ID " +
                                          _vm._s(status.id_historico) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
          ])
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "560" },
          model: {
            value: _vm.dialogConfirm,
            callback: function($$v) {
              _vm.dialogConfirm = $$v
            },
            expression: "dialogConfirm"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c(
                    "v-avatar",
                    {
                      staticClass: "mr-3",
                      attrs: { color: "red lighten-5", size: "40" }
                    },
                    [
                      _c("v-icon", { attrs: { color: "error" } }, [
                        _vm._v("mdi-alert-circle-outline")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" Excluir histórico ")
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("p", [
                    _vm._v(
                      " Deseja realmente excluir este histórico? Essa ação "
                    ),
                    _c("strong", [_vm._v("não pode ser desfeita")]),
                    _vm._v(
                      " e ficará registrada na auditoria com o seu usuário. "
                    )
                  ]),
                  _c(
                    "v-card",
                    {
                      staticClass: "pa-3 grey lighten-5",
                      attrs: { outlined: "" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.statusSelected
                                  ? _vm.dataExibicao(_vm.statusSelected)
                                  : ""
                              )
                            )
                          ]),
                          _c(
                            "v-chip",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                "x-small": "",
                                color: "primary",
                                outlined: ""
                              }
                            },
                            [
                              _vm._v(
                                " #" +
                                  _vm._s(
                                    _vm.statusSelected
                                      ? _vm.codigoStatus(_vm.statusSelected)
                                      : ""
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "mt-1" }, [
                        _vm._v(" " + _vm._s(_vm.statusSelected.DESCRICAO) + " ")
                      ]),
                      _vm.statusSelected.user_id
                        ? _c(
                            "div",
                            { staticClass: "caption grey--text mt-1" },
                            [
                              _vm._v(
                                " Registrado por " +
                                  _vm._s(
                                    _vm.statusSelected.ds_login ||
                                      _vm.statusSelected.nm_user
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.loadingHistorico },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirm = false
                        }
                      }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", loading: _vm.loadingHistorico },
                      on: {
                        click: function($event) {
                          return _vm.deleteHistory(
                            _vm.statusSelected.id_historico
                          )
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-trash-can-outline")
                      ]),
                      _vm._v(" Excluir ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "650px", persistent: "" },
          model: {
            value: _vm.dialogHistorico,
            callback: function($$v) {
              _vm.dialogHistorico = $$v
            },
            expression: "dialogHistorico"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "white" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.modoEdicao ? "mdi-pencil-circle" : "mdi-plus-circle"
                      )
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.modoEdicao
                          ? "Editar Histórico"
                          : "Adicionar Novo Histórico"
                      ) +
                      " "
                  ),
                  _c("v-spacer"),
                  _vm.modoEdicao && _vm.formHistorico.id_historico
                    ? _c(
                        "v-chip",
                        { attrs: { small: "", color: "white", outlined: "" } },
                        [
                          _vm._v(
                            " ID " +
                              _vm._s(_vm.formHistorico.id_historico) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.fecharFormularioHistorico }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-6" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4 caption",
                      attrs: { dense: "", outlined: "", type: "info" }
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-shield-account-outline")
                      ]),
                      _vm._v(
                        " Esta " +
                          _vm._s(_vm.modoEdicao ? "edição" : "criação") +
                          " será gravada no seu usuário "
                      ),
                      _c("strong", [
                        _vm._v("(" + _vm._s(_vm.usuarioLogado) + ")")
                      ]),
                      _vm._v(
                        " e gerará trilha de auditoria nos comentários do título. "
                      )
                    ],
                    1
                  ),
                  _vm.modoEdicao
                    ? _c(
                        "v-card",
                        {
                          staticClass: "pa-3 mb-4 grey lighten-5",
                          attrs: { outlined: "" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "caption grey--text mb-1" },
                            [_vm._v(" REGISTRO ORIGINAL ")]
                          ),
                          _c("div", [
                            _c("strong", [_vm._v(_vm._s(_vm.resumoOriginal))])
                          ]),
                          _vm.registroOriginal.user_id
                            ? _c("div", { staticClass: "caption mt-1" }, [
                                _vm._v(" Responsável atual: "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.registroOriginal.ds_login ||
                                        _vm.registroOriginal.nm_user ||
                                        "#" + _vm.registroOriginal.user_id
                                    )
                                  )
                                ]),
                                _vm._v(" → será substituído por você "),
                                _c("strong", [
                                  _vm._v("(" + _vm._s(_vm.usuarioLogado) + ")")
                                ]),
                                _vm._v(". ")
                              ])
                            : _c("div", { staticClass: "caption mt-1" }, [
                                _vm._v(
                                  " Registro de sistema → passará a constar o seu usuário "
                                ),
                                _c("strong", [
                                  _vm._v("(" + _vm._s(_vm.usuarioLogado) + ")")
                                ]),
                                _vm._v(". ")
                              ])
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "v-form",
                    {
                      ref: "formHistorico",
                      model: {
                        value: _vm.formHistoricoValido,
                        callback: function($$v) {
                          _vm.formHistoricoValido = $$v
                        },
                        expression: "formHistoricoValido"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Código do status *",
                                  outlined: "",
                                  dense: "",
                                  type: "number",
                                  hint: "Ex.: 220, 250, 105",
                                  "persistent-hint": "",
                                  rules: _vm.regrasStatus,
                                  required: ""
                                },
                                model: {
                                  value: _vm.formHistorico.cd_status,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formHistorico,
                                      "cd_status",
                                      $$v
                                    )
                                  },
                                  expression: "formHistorico.cd_status"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "8" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Data do histórico *",
                                  outlined: "",
                                  dense: "",
                                  type: "datetime-local",
                                  rules: _vm.regrasDataHistorico,
                                  required: ""
                                },
                                model: {
                                  value: _vm.formHistorico.dt_historico,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formHistorico,
                                      "dt_historico",
                                      $$v
                                    )
                                  },
                                  expression: "formHistorico.dt_historico"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Data movimento (arquivo)",
                                  outlined: "",
                                  dense: "",
                                  type: "datetime-local",
                                  hint: "Opcional — limpe para remover",
                                  "persistent-hint": "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.formHistorico.dt_arquivo_movimento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formHistorico,
                                      "dt_arquivo_movimento",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                    formHistorico.dt_arquivo_movimento\n                                "
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Data ocorrência",
                                  outlined: "",
                                  dense: "",
                                  type: "date",
                                  hint: "Opcional",
                                  "persistent-hint": "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.formHistorico.dt_ocorrencia,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formHistorico,
                                      "dt_ocorrencia",
                                      $$v
                                    )
                                  },
                                  expression: "formHistorico.dt_ocorrencia"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "pa-6 pt-0" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        loading: _vm.loadingSalvarHistorico,
                        disabled:
                          !_vm.formHistoricoValido || _vm.loadingSalvarHistorico
                      },
                      on: { click: _vm.salvarHistorico }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.modoEdicao ? "mdi-content-save" : "mdi-plus"
                          )
                        )
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.modoEdicao ? "Salvar alterações" : "Adicionar"
                          ) +
                          " "
                      )
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey",
                        text: "",
                        disabled: _vm.loadingSalvarHistorico
                      },
                      on: { click: _vm.fecharFormularioHistorico }
                    },
                    [_vm._v(" Cancelar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.feedbackSnackbar
        ? _c("Snackbar", {
            attrs: {
              "data-html2canvas-ignore": "",
              mostrarSnackbar: _vm.feedbackSnackbar,
              corSnackbar: _vm.feedbackSnackbarColor,
              mensagemSnackbar: _vm.mensagemfeedbackSnackbar
            },
            on: {
              fecharSnackbar: function($event) {
                _vm.feedbackSnackbar = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }